import store from '@/store';

import Vue from 'vue';
import Router from 'vue-router';
import Impressum from '@/views/Impressum.vue';
import Dsgvo from '@/views/Dsgvo.vue';
import Home from '@/views/main/Home.vue';
import MainLayout from '@/views/main/Layout.vue';
import AuthLayout from '@/views/auth/Layout.vue';
import Login from '@/views/auth/Login.vue';
import ChangePassword from '@/views/auth/ChangePassword.vue';

Vue.use(Router);

function isLoggedIn(to: any, from: any, next: any) {
  if (!store.getters['auth/user']) {
    next({name: 'Login'});
  } else {
    next();
  }
}

function restoreSession(to: any, from: any, next: any) {
  if (!store.getters['auth/session']) {
    const session = sessionStorage.getItem('session');
    if (session) {
      store.commit('auth/setSession', JSON.parse(session));
    }
  }
  next();
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Main',
      component: MainLayout,
      redirect: {name: 'Home'},
      beforeEnter: restoreSession,
      children: [
        {
          path: '',
          name: 'Home',
          component: Home,
        },
      ],
    },
    {
      path: '/login',
      name: 'oldLogin',
      redirect: {name: 'Login'},
    },
    {
      path: '/auth',
      name: 'Auth',
      component: AuthLayout,
      redirect: {name: 'Login'},
      children: [
        {
          path: '',
          name: 'Login',
          component: Login,
        },
        {
          path: '/changePassword',
          name: 'ChangePassword',
          component: ChangePassword,
          beforeEnter: isLoggedIn,
        },
      ],
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: Impressum,
    },
    {
      path: '/dsgvo',
      name: 'DSGVO',
      component: Dsgvo,
    },
  ],
});
